export const generateAriaProps = ({
  hasError,
  label,
  placeholder,
  name,
  hint,
}: {
  hasError?: boolean;
  label?: string;
  placeholder?: string;
  name?: string;
  hint?: string;
}) => {
  return {
    'aria-label': !label ? placeholder : undefined,
    'aria-invalid': hasError,
    'aria-describedby': hasError ? `${name}-error` : hint ? `${name}-hint` : placeholder,
  };
};

/**
 * The inputs in this folder accept objects for errors, however React will throw a runtime exception if
 * we try to render an object as a child, yuck!
 *
 * As of React 18 the children prop was modified to no longer accept an object so we can catch
 * this when writing code. Rather than try to untangle the types in these deprecated components
 * this util will stringify any non string values so we can display without risk of exceptions.
 *
 * Do not copy this util or use it in any new code.
 *
 * background: https://solverfox.dev/writing/no-implicit-children/
 */
export const getErrorDisplayText = (error: string | object | undefined) => {
  if (typeof error === 'string') {
    return error;
  }

  return JSON.stringify(error);
};
